import '../../vendors/swiper/swiper.scss'

import Swiper from 'swiper'
import { Navigation, Pagination } from 'swiper/modules'

import { currentDevice } from '../../core/utils/currentDevice'
import { FASTBOOKING_EVENTS } from '../../shared/fastbooking/constants'
import fastbooking from '../../shared/fastbooking/ibh_fastbooking'
import { transformToLiteYoutube } from '../../utils/control_youtube_video'

import { initializeUtagEvents } from './introduction_module.analytics'

const block_name = '.introduction-module'

function addedMarginMobileLegalNotice() {
  if (
    IB.currentPageType.get() === 'page' &&
    currentDevice.isMobile &&
    !document.body.classList.contains('inspiration-guide')
  ) {
    const introModule = document.querySelector('.introduction-module')
    introModule.classList.add('added-margin-top-mobile')
  }
}

function initSwiper(block) {
  Swiper.use([Pagination, Navigation])

  const swiperDefault = block.querySelector('.js-swiper-default')

  if (!swiperDefault) return

  const swiperDefaultPagination = swiperDefault.querySelector(':scope > .js-swiper-pagination')
  const swiperDefaultNavigationNext = swiperDefault.querySelector(':scope > .js-swiper-button-next')
  const swiperDefaultNavigationPrev = swiperDefault.querySelector(':scope > .js-swiper-button-prev')

  new Swiper(swiperDefault, {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: false,
    pagination: {
      el: swiperDefaultPagination,
      clickable: false,
    },
    navigation: {
      nextEl: swiperDefaultNavigationNext,
      prevEl: swiperDefaultNavigationPrev,
    },
    lazyPreloadPrevNext: 1,
  })
}

function addCodeParamToHotelLinks(code) {
  if (code !== '') {
    // Concat from code to hotel card-container and comparator card container
    document.querySelectorAll('.card-container a.title-link').forEach(function (link) {
      const href = link.getAttribute('href')
      let url = href
      if (href.indexOf('promo_code=') >= 0) {
        url = href.replace(/(promo_code=)[a-z0-9]+/gi, `$1${code}`) /* Replace promocode if inserted before */
      } else if (href.indexOf('?') >= 0) {
        url = `${href}&promo_code=${code}` /* Concat parameter if others introduced previously */
      } else {
        url = `${href}?promo_code=${code}` /* Insert as first parameter */
      }

      link.setAttribute('href', url)
    })
  }
}

function copyToClipboard(element) {
  const temp = document.createElement('input')
  temp.setAttribute('readonly', 'true')
  document.body.appendChild(temp)
  temp.value = element.textContent
  temp.select()
  document.execCommand('copy')
  document.body.removeChild(temp)
}

function loadGif(block) {
  const img = block.querySelector('.image')

  if (!img) return
  if (typeof img.dataset.gif === 'undefined' || img.dataset.gif === null || !img.dataset.gif.length) return
  block.querySelector('source').setAttribute('srcset', img.dataset.gif)
}

function handleInspirationGuideImages() {
  if (document.body.classList.contains('inspiration-guide')) {
    document.querySelectorAll('.image picture:not(.loaded)').forEach(function (pictureElement) {
      pictureElement.querySelectorAll('source').forEach(function (sourceElement) {
        const srcset = sourceElement.dataset.srcset

        if (srcset) {
          sourceElement.setAttribute('srcset', srcset)
        }
      })
      pictureElement.classList.add('loaded')
    })
  }
}

function initIntroductionModule(block_id) {
  addedMarginMobileLegalNotice()
  const blocks =
    block_id === undefined
      ? document.querySelectorAll(block_name)
      : document.querySelectorAll(`${block_name}[data-block-id="${block_id}"]`)

  blocks.forEach(function (block) {
    const trigger = currentDevice.isDesktop ? block.querySelector('.offer-code') : block.querySelector('.secondary-btn')
    const desc = block.querySelector('.textual-content .desc')
    let timeout

    const view_more_link = block.querySelector('.js-link-see-more')

    if (trigger) {
      trigger.addEventListener('click', function (e) {
        if (!currentDevice.isDesktop) e.preventDefault()
        let this_offer
        if (currentDevice.isDesktop) {
          this_offer = this.parentElement.querySelector('.offer-code')
        } else {
          this_offer = this.parentElement.querySelector('.block .offer-code')
        }

        const code = this_offer.querySelector('.code').innerHTML
        const copied_msg = this_offer.parentElement.querySelector('.code-applied')

        block.querySelectorAll('.visible').forEach(el => el.classList.remove('visible'))

        if (this_offer.classList.contains('copied')) return
        if (typeof timeout === 'number') clearTimeout(timeout)

        // remove copied state from any other offer because we are changing activated code very quickly
        document.querySelectorAll('.offer-code.copied').forEach(el => el.classList.remove('copied'))
        copyToClipboard(this_offer.querySelector('.code'))
        addCodeParamToHotelLinks(code)
        fastbooking.setPromocode(code)
        document.addEventListener(FASTBOOKING_EVENTS.RESET_PROMOCODE, () => {
          document.querySelectorAll('.offer-code.copied').forEach(el => el.classList.remove('copied'))
        })
        copied_msg.classList.add('visible')
        timeout = setTimeout(function () {
          copied_msg.classList.remove('visible')
          this_offer.classList.add('copied')
        }, 3000)

        if (currentDevice.isMobile) {
          const f_mobile = document.getElementById('fastbooking-mobile')
          document.getElementById('mobile-input-promo').style.display = 'block'
          f_mobile.querySelector('.link-promo').classList.add('active')
          const clearPromo = f_mobile.querySelector('.clear-promo')
          if (clearPromo) clearPromo.classList.remove('is-hidden')
        }
      })
    }

    if (view_more_link) {
      view_more_link.addEventListener('click', function () {
        block.classList.toggle('opened')
        // We add focus to desc block for better accessibility
        if (desc) {
          if (block.classList.contains('opened')) {
            desc.focus()
          } else {
            desc.blur()
          }
        }
      })
    }
    // We add id's on desc block, role="region" and aria-controls for better accessibility
    if (desc && block.getAttribute('data-block-id') !== undefined) {
      desc.id = `desc-${block.getAttribute('data-block-id')}`
      view_more_link.setAttribute('aria-controls', `desc-${block.getAttribute('data-block-id')}`)
    }

    loadGif(block)
    handleInspirationGuideImages()
    const elementTruncableBlock = Array.from(block.querySelectorAll('.js-is-truncable'))
    // Throwing "truncable" duplicates the js-link-see-more click event.
    // The element is cloned, as cloning does not clone events.
    const linksMoreContent = Array.from(block.querySelectorAll('.js-link-see-more'))

    linksMoreContent.forEach(element => {
      const elementClone = element.cloneNode(true)
      element.parentNode.replaceChild(elementClone, element)
    })

    if (Array.isArray(elementTruncableBlock) && elementTruncableBlock.length > 0) {
      if (typeof IB.truncable !== 'undefined' && typeof IB.truncable.init === 'function') {
        IB.truncable.init(elementTruncableBlock)
      }
    }

    initSwiper(block)
  })
  initializeUtagEvents()
}
//Initialize click handlers for videos
function setupVideoClickListeners() {
  document.querySelectorAll('.introduction-module').forEach(module => {
    module.addEventListener('click', function (e) {
      if (e.target.closest('.image.with-play')) {
        const videoElement = e.target.closest('.image.with-play')
        transformToLiteYoutube(videoElement)
      }
    })
  })
}
initIntroductionModule()
setupVideoClickListeners()
